import React from 'react';
import {Link} from 'react-router-dom';
import { IMAGES } from '../constants/theme';

const DzMedia = ({Image, order}) =>{
    return(
        <div className={`col-xl-3 col-md-6 dz-media-wrapper dz-media-order-${order}`}>
            <div className="dz-media">
                <img src={Image} alt="" />
            </div>
        </div>
    )
}

const DzInfo1 = ({title, subtitle, order}) =>{
    return(
        <div className={`col-xl-3 col-md-6 dz-info-wrapper dz-info-order-${order}`}>
            <div className="dz-info bg-secondary">
                <div className="clearfix text-white">
                    <span className="text-primary subtitle">{title}</span>
                    <h4 className="title text-white">{subtitle}</h4>
                    <p>Join our community of motivated individuals who support each other in achieving their fitness dreams.</p>
                    <Link to={"/services-details"} className="btn btn-primary btn-skew"><span>Read More</span></Link>
                </div>
            </div>
        </div>        
    )
}
const DzInfo2 = ({title, subtitle, order}) =>{
    return(
        <div className={`col-xl-3 col-md-6 dz-info-wrapper dz-info-order-${order}`}>
            <div className="dz-info bg-primary">
                <div className="clearfix theme-text-color">
                    <span className="subtitle">{title}</span>
                    <h4 className="title theme-text-color">{subtitle}</h4>
                    <p>We teach you sustainable habits that last a lifetime.</p>
                    <Link to={"/services-details"} className="btn btn-secondary btn-skew"><span>Read More</span></Link>
                </div>
            </div>
        </div>
    )
}
const DzInfo3 = ({title, subtitle, order}) =>{
    return(
        <div className={`col-xl-3 col-md-6 dz-info-wrapper dz-info-order-${order}`}>
            <div className="dz-info bg-secondary">
                <div className="clearfix text-white">
                    <span className="text-primary subtitle">{title}</span>
                    <h4 className="title text-white">{subtitle}</h4>
                    <p>Our approach ensures you gain quality muscle mass, not just empty calories.</p>
                    <Link to={"/services-details"} className="btn btn-primary btn-skew"><span>Read More</span></Link>
                </div>
            </div>
        </div>        
    )
}
const DzInfo4 = ({title, subtitle, order}) =>{
    return(
        <div className={`col-xl-3 col-md-6 dz-info-wrapper dz-info-order-${order}`}>
            <div className="dz-info bg-primary">
                <div className="clearfix theme-text-color">
                    <span className="subtitle">{title}</span>
                    <h4 className="title theme-text-color">{subtitle}</h4>
                    <p>Get personalized support, accountability, and expert advice.</p>
                    <Link to={"/services-details"} className="btn btn-secondary btn-skew"><span>Read More</span></Link>
                </div>
            </div>
        </div>
    )
}
const FitnessTraining = () => {
    return (
        <>
            <div className="row g-0 fitness-training-container">
                <DzInfo1 title="BODY SHAPE" subtitle="MOTIVATION" order={1} />
                <DzMedia  Image = {IMAGES.bloggrid1 } order={2} />
                <DzMedia  Image = {IMAGES.bloggrid4 } order={4} />
                <DzInfo2 title="RELAX PROGRAM" subtitle="FAT LOSS" order={3} />
                <DzInfo4 title="CARDIO WORKFLOW" subtitle="PERSONAL COACHING" order={5} />
                <DzMedia  Image = {IMAGES.bloggrid2 } order={6} />
                <DzMedia  Image = {IMAGES.bloggrid6 } order={8} />                
                <DzInfo3 title="POWER-PRO" subtitle="WEIGHT GAIN" order={7} />
            </div>
            <style>{`
                /* Mobile only - alternating layout */
                @media (max-width: 767px) {
                    .fitness-training-container {
                        display: flex;
                        flex-direction: column;
                    }
                    
                    .fitness-training-container .dz-info-wrapper,
                    .fitness-training-container .dz-media-wrapper {
                        width: 100% !important;
                        max-width: 100% !important;
                        flex: 0 0 100% !important;
                    }
                    
                    .dz-info-order-1 { order: 1; }
                    .dz-media-order-2 { order: 2; }
                    .dz-info-order-3 { order: 3; }
                    .dz-media-order-4 { order: 4; }
                    .dz-info-order-5 { order: 5; }
                    .dz-media-order-6 { order: 6; }
                    .dz-info-order-7 { order: 7; }
                    .dz-media-order-8 { order: 8; }
                }
                
                /* Tablet and Web - original layout (reset order) */
                @media (min-width: 768px) {
                    .dz-info-order-1,
                    .dz-info-order-3,
                    .dz-info-order-5,
                    .dz-info-order-7,
                    .dz-media-order-2,
                    .dz-media-order-4,
                    .dz-media-order-6,
                    .dz-media-order-8 {
                        order: 0 !important;
                    }
                }
            `}</style>
        </>
    );
};

export default FitnessTraining;